import HomeCard from "../../../UI/HomeCard";
import ExperienceSection from "./experience";
const Experience = () => {
  return (
    <HomeCard>
      <h2>Where I've worked?</h2>
      <ExperienceSection />
    </HomeCard>
  );
};
export default Experience;
